/**
 * ¿Cómo usarlo?
 *    
 *    1) Importar en componente
 *    import { getFormattedDates } from 'src/app/core/utils/date-utils';
 *    
 *    2) Especificar la cantidad de meses a considerar para la "fecha inicial"
 *    const { fechaInicial, fechaFinal } = getFormattedDates(12);
 *  
 *    Ejemplo: 
 *    - Para 1 mes atrás (por defecto):
 *    - getFormattedDates()
 *
 *    - Para 2 meses atrás:
 *    - getFormattedDates(2)
 *
 *    - Para 12 meses atrás (1 año):
 *    - getFormattedDates(12)
 * 
 */

export function getFormattedDates(monthsBack: number = 1): { fechaInicial: string; fechaFinal: string } {
  const today = new Date();
  const fechaFinal = new Date(today);

  const fechaInicial = new Date(today);
  fechaInicial.setMonth(today.getMonth() - monthsBack);

  // Asegura que no caiga en un día inválido del mes
  if (today.getDate() < fechaInicial.getDate()) {
    fechaInicial.setDate(today.getDate());
  }

  const formatDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return {
    fechaInicial: formatDate(fechaInicial),
    fechaFinal: formatDate(fechaFinal),
  };
}

/**
 * Ejemplo de uso:
 * 
 * const fechas = getFormattedDatesByDays(10);
 * console.log(fechas.fechaInicial); // 10 días atrás
 * console.log(fechas.fechaFinal);   // hoy
 * 
 */
export function getFormattedDatesByDays(daysBack: number = 7): { fechaInicial: string; fechaFinal: string } {
  const today = new Date();
  const fechaFinal = new Date(today);

  const fechaInicial = new Date(today);
  fechaInicial.setDate(today.getDate() - daysBack);

  const formatDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return {
    fechaInicial: formatDate(fechaInicial),
    fechaFinal: formatDate(fechaFinal),
  };
}


export function getFechasDesdeAntiguedad(filtro: string): { fechaInicial: string; fechaFinal: string } {
  switch (filtro) {
    case "3daysago":
      return getFormattedDatesByDays(3);
    case "7daysago":
      return getFormattedDatesByDays(7);
    case "15daysago":
      return getFormattedDatesByDays(15);
    case "30daysago":
      return getFormattedDatesByDays(30);
    case "more30daysago":
      return getFormattedDates(3); // ← meses atrás
    default:
      return getFormattedDatesByDays(18); // fallback
  }
}